import React, { useRef } from 'react';
import TouchRipple from '@mui/material/ButtonBase/TouchRipple';
import useStyles from './styles';
export default function RippleEffect(_ref) {
  let children = _ref.children,
    className = _ref.className;
  const classes = useStyles();
  const rippleRef = useRef(null);
  const onRippleStart = e => {
    rippleRef.current.start(e);
  };
  const onRippleStop = e => {
    rippleRef.current.stop(e);
  };
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(className || '', " ").concat(classes.rippleContainer),
    onMouseDown: onRippleStart,
    onMouseUp: onRippleStop
  }, children, /*#__PURE__*/React.createElement(TouchRipple, {
    ref: rippleRef,
    center: false
  }));
}